import { captureError } from "@/utils/common.helpers";
import { API_ROUTES } from "../apiRoutes";
import { HttpClient } from "../HttpClient";
import { REQUEST_METHODS } from "../configs.apiClient";

export class MessagingAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async triggerWhatsAppMessage({ postTrialPrice }: { postTrialPrice: number }) {
    try {
      const method = REQUEST_METHODS.POST;
      const endpoint = API_ROUTES.messaging.triggerWhatsAppMessage;

      await this.httpClient.request({
        endpoint,
        options: {
          method,
        },
        body: {
          template: "TRIAL_FAIL",
          templateValues: {
            postTrialPrice: postTrialPrice.toString(),
          },
        },
      });
    } catch (error) {
      console.error("Error while triggering whatsapp message", error);
      throw captureError(error);
    }
  }
}
